import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import allUsers from './img/allUsers.svg';
import agents from './img/agents.svg';
import players from './img/players.svg';
import createAgent from './img/createAgent.svg';
import createPlayer from './img/createPlayer.svg';
import generalReport from './img/generalReport.svg';
import depositsAndWithdrawals from './img/depositsAndWithdrawals.svg';
import playerHistory from './img/playerHistory.svg';
import playerAndAgentDetail from './img/playerAndAgentDetail.svg';
import sportBets from './img/sportBets.svg';
import myDebtAccount from './img/myDebtAccount.svg';
import howToStart from './img/howToStart.svg';
import playerDepositsSVG from './img/playerDeposits.svg';
import bonusSVG from './img/bonus.svg';

import allUsersWhite from './img/white/allUsers.svg';
import agentsWhite from './img/white/agents.svg';
import playersWhite from './img/white/players.svg';
import createAgentWhite from './img/white/createAgent.svg';
import createPlayerWhite from './img/white/createPlayer.svg';
import generalReportWhite from './img/white/generalReport.svg';
import depositsAndWithdrawalsWhite from './img/white/depositsAndWithdrawals.svg';
import playerHistoryWhite from './img/white/playerHistory.svg';
import playerAndAgentDetailWhite from './img/white/playerAndAgentDetail.svg';
import sportBetsWhite from './img/white/sportBets.svg';
import myDebtAccountWhite from './img/white/myDebtAccount.svg';
import howToStartWhite from './img/white/howToStart.svg';
import playerDepositsWhite from './img/white/playerDeposits.svg';
import statisticsSVG from './img/statistics.svg';
import statisticsWhiteSVG from './img/white/statistics.svg';
import requestHistorySVG from './img/requestHistory.svg';
import requestHistoryWhiteSVG from './img/white/requestHistory.svg';
import referralsSVG from './img/referrals.svg';
import referralsWhiteSVG from './img/white/referrals.svg';
import cashbackHistorySVG from './img/cashbackHistory.svg';
import cashbackHistoryWhiteSVG from './img/white/cashbackHistory.svg';
import bonusWhiteSVG from './img/white/bonus.svg';

export const useSidebarMenu = () => {
  const { playerDeposits } = useSelector(state => state.reports);

  const result = useMemo(() => [
    {
      title: 'myStatistic',
      route: '/statistic',
      routeForActiveTab: '/statistic',
      img: statisticsSVG,
      whiteImg: statisticsWhiteSVG,
      level: 1,
    },
    {
      title: 'users',
      route: '#',
      routeForActiveTab: '',
      level: 0,
      children: [
        {
          title: 'allUsers',
          route: '/users/all',
          routeForActiveTab: '/users/all',
          img: allUsers,
          level: 1,
          whiteImg: allUsersWhite,
        },
        {
          title: 'agents',
          route: '/users/agents',
          routeForActiveTab: '/users/agents',
          img: agents,
          level: 1,
          whiteImg: agentsWhite,
        },
        {
          title: 'players',
          route: '/users/players',
          routeForActiveTab: '/users/players',
          img: players,
          level: 1,
          whiteImg: playersWhite,
        },
        {
          title: 'referralPlayers',
          route: '/users/referrals',
          routeForActiveTab: '/users/referrals',
          img: referralsSVG,
          level: 1,
          whiteImg: referralsWhiteSVG,
        },
        {
          title: 'createAgent',
          route: '/user/create-agent',
          routeForActiveTab: '/user/create-agent',
          img: createAgent,
          level: 1,
          whiteImg: createAgentWhite,
        },
        {
          title: 'createPlayer',
          route: '/user/create-player',
          routeForActiveTab: '/user/create-player',
          img: createPlayer,
          level: 1,
          whiteImg: createPlayerWhite,
        },
      ],
    },
    {
      title: 'financialReports',
      route: '#',
      routeForActiveTab: '',
      level: 0,
      children: [
        {
          title: 'generalReport',
          img: generalReport,
          route: '/reports/financial-reports/general',
          routeForActiveTab: '/reports/financial-reports/general',
          level: 1,
          whiteImg: generalReportWhite,
        },
        {
          title: 'depositsAndWithdrawals',
          img: depositsAndWithdrawals,
          route: '/reports/financial-reports/cash',
          routeForActiveTab: '/reports/financial-reports/cash',
          level: 1,
          whiteImg: depositsAndWithdrawalsWhite,
        },
        {
          title: 'playerDeposits',
          img: playerDepositsSVG,
          route: '/reports/financial-reports/player-deposits',
          routeForActiveTab: '/reports/financial-reports/player-deposits',
          level: 1,
          whiteImg: playerDepositsWhite,
          count: playerDeposits.count,
        },
        {
          title: 'requestHistory',
          img: requestHistorySVG,
          whiteImg: requestHistoryWhiteSVG,
          route: '/reports/financial-reports/request-history',
          routeForActiveTab: '/reports/financial-reports/request-history',
          level: 1,
        },
        {
          title: 'cashbackHistory',
          img: cashbackHistorySVG,
          route: '/reports/financial-reports/cashback-history',
          routeForActiveTab: '/reports/financial-reports/cashback-history',
          level: 1,
          whiteImg: cashbackHistoryWhiteSVG,
          checkForActiveCashback: true,
        },
      ],
    },
    {
      title: 'playerReports',
      route: '#',
      routeForActiveTab: '',
      level: 0,
      children: [
        {
          title: 'playerHistory',
          img: playerHistory,
          route: '/reports/player-reports/player-history',
          routeForActiveTab: '/reports/player-reports/player-history',
          level: 1,
          whiteImg: playerHistoryWhite,
        },
        // {
        //   title: 'playerAndAgentDetail',
        //   img: playerAndAgentDetail,
        //   route: '/reports/player-reports/detail-by-player',
        //   routeForActiveTab: '/reports/player-reports/detail-by-player',
        //   level: 1,
        //   whiteImg: playerAndAgentDetailWhite,
        // },
        {
          title: 'sportBets',
          img: sportBets,
          route: '/reports/player-reports/sport-bets',
          routeForActiveTab: '/reports/player-reports/sport-bets',
          level: 1,
          whiteImg: sportBetsWhite,
        },
      ],
    },
    {
      title: 'finance',
      route: '#',
      routeForActiveTab: '',
      level: 0,
      children: [
        {
          title: 'myDebtAccount',
          img: myDebtAccount,
          route: '/finance/my-debt-account',
          routeForActiveTab: '/finance/my-debt-account',
          level: 1,
          whiteImg: myDebtAccountWhite,
        },
        // {
        //   title: 'howToStart',
        //   img: howToStart,
        //   route: '/finance/how-to-start',
        //   routeForActiveTab: '/finance/how-to-start',
        //   level: 1,
        //   whiteImg: howToStartWhite,
        // },
      ],
    },
    {
      title: 'bonusProgram',
      route: '#',
      routeForActiveTab: '',
      level: 0,
      children: [
        {
          title: 'giftManagement',
          img: bonusSVG,
          route: '/bonus-promo/management',
          routeForActiveTab: '/bonus-promo/management',
          level: 1,
          whiteImg: bonusWhiteSVG,
          withStartsWith: true,
        },
      ],
    },
  ], [playerDeposits.count])

  return result
};

export const agentsItem = {
  title: 'agents',
  routeForActiveTab: '',
  img: allUsers,
  level: 0,
};
